import React from 'react';

import {SurveyListItem, CreativeBox, BordomatikBox} from 'client/common/types';
import {useCancelSurveyModeration, useCopySurvey} from 'client/common/hooks/survey';
import {SurveyState} from 'client/common/store/reducers/survey/types';
import {genSurveyLink, genStatisticsLink} from 'client/common/utils/survey-link';

import CreativeCard from 'client/creatives/components/creative-card';
import {useCreative} from 'client/creatives/hooks/creatives';

import './creative-list.css';

type ListItemProps = Pick<
    SurveyListItem,
    'slug' | 'state' | 'name' | 'isDemo' | 'audience' | 'resources'
> & {
    box: CreativeBox | BordomatikBox;
};

export function ListItem(props: ListItemProps) {
    const {slug, state, box, name, isDemo, audience, resources} = props;

    const {stat, creative, additionalParameters, brand, industry, targeting} = useCreative({
        slug,
        box,
        resources,
        state,
        audience
    });

    const copySurvey = useCopySurvey(slug, name, {openAfterCopy: true});
    const cancelModeration = useCancelSurveyModeration(slug);

    const link =
        state === SurveyState.Completed
            ? genStatisticsLink({slug, surveyType: box.name, isRelative: true})
            : genSurveyLink({
                  slug,
                  surveyType: box.name,
                  isRelative: true
              });

    const onCopy = () => {
        void copySurvey({
            access: true,
            audience: true
        });
    };

    return (
        <CreativeCard
            slug={slug}
            state={state}
            name={name}
            withMenu={!isDemo}
            link={link}
            stat={stat}
            creative={creative}
            additionalParameters={additionalParameters}
            brand={brand}
            industry={industry}
            targeting={targeting}
            onCopy={onCopy}
            onCancelModeration={state === SurveyState.Moderation ? cancelModeration : undefined}
        />
    );
}
